import React, { useEffect, useRef } from "react";
import style from "./EuleriagymMonodimensionalBalanceChart.module.sass";
import { monodimensionalChart } from "../euleriagymBalanceCharts";
import { chartSync } from "../chartSync";

function EuleriagymMonodimensionalBalanceChart(props) {
  const {
    colors,
    clampedData,
    data,
    directions,
    enableLeft,
    enableRight,
    labels,
    title
  } = props;

  const canvasContainer = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    renderChart();
  }, [clampedData, labels]);

  useEffect(() => {
    updateChartColors();
  }, [enableLeft, enableRight]);

  const getDatasets = (samples) => {
    return samples.map((item, index) => ({
      data: item,
      label: labels[index],
      borderColor: colors[index],
      backgroundColor: colors[index],
    }));
  };

  const renderChart = () => {
    if (canvasContainer.current) {
      // Rimuove vecchio canvas se presente
      let canvas = canvasContainer.current.querySelector("canvas");
      if (canvas) canvas.remove();

      // Crea nuovo canvas
      canvas = document.createElement("canvas");
      canvasContainer.current.appendChild(canvas);

      const datasets = getDatasets(clampedData);
      const tooltipDatasets = getDatasets(data);

      // Crea chart
      chartInstance.current = monodimensionalChart(
        canvas,
        datasets,
        labels,
        tooltipDatasets
      );

      // === SYNC HOVER START (ottimizzato) ===
      let lastMove = 0;
      canvas.addEventListener("mousemove", (event) => {
        const now = performance.now();
        // throttling: massimo 50 fps circa
        if (now - lastMove < 50) return;
        lastMove = now;

        if (!chartInstance.current || !chartInstance.current.data) return;

        const points = chartInstance.current.getElementsAtEventForMode(
          event,
          "nearest",
          { intersect: true },
          false
        );
        if (points.length > 0) {
          const index = points[0].index;
          chartSync.publish(index); // notifica agli altri grafici
        }
      });

      canvas.addEventListener("mouseout", () => {
        chartSync.publish(null); // cancella hover globale
      });
      // === SYNC HOVER END ===

      // === SYNC SUBSCRIBE (ottimizzato e fluido) ===
      if (!chartInstance.current.__syncSubscribed) {
        chartInstance.current.__syncSubscribed = true;

        chartSync.subscribe((hoverIndex) => {
          const chart = chartInstance.current;
          if (!chart) return;

          // evita update ridondanti
          if (chart._lastHoverIndex === hoverIndex) return;
          chart._lastHoverIndex = hoverIndex;

          if (hoverIndex === null) {
            chart.setActiveElements([]);
            chart.tooltip.setActiveElements([], { x: 0, y: 0 });
            requestAnimationFrame(() => chart.update("none"));
            return;
          }

          const meta = chart.getDatasetMeta(0);
          if (!meta || !meta.data[hoverIndex]) return;

          // 🔹 attiva TUTTI i dataset allo stesso indice
          const allElements = chart.data.datasets.map((_, datasetIndex) => ({
            datasetIndex,
            index: hoverIndex
          }));

          chart.setActiveElements(allElements);
          chart.tooltip.setActiveElements(allElements, {
            x: meta.data[hoverIndex].x,
            y: meta.data[hoverIndex].y
          });

          requestAnimationFrame(() => chart.update("none"));
        });
      }
      // === SYNC SUBSCRIBE END ===
    }
  };

  const updateChartColors = () => {
    if (chartInstance.current && enableLeft != null && enableRight != null) {
      chartInstance.current.data.datasets.map((dataset, index) => {
        if (index === 0) {
          dataset.borderColor = enableLeft
            ? colors[index]
            : "rgba(255, 164, 17, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        } else {
          dataset.borderColor = enableRight
            ? colors[index]
            : "rgba(167, 120, 255, 0.2)";
          dataset.backgroundColor = dataset.borderColor;
        }
      });
      chartInstance.current.update("none");
    }
  };

  return (
    <div className={style.chartWrapper}>
      <div className={style.chartTitle}>{title}</div>
      <div className={style.chartRow}>
        <div className={style.xUnit}>[s]</div>
        <div className={style.yUnit}>[cm]</div>
        <div ref={canvasContainer} className={style.canvasWrapper}></div>
        <div className={style.labels}>
          {directions.map((direction, index) => (
            <div key={index} className={style.label}>
              {direction}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EuleriagymMonodimensionalBalanceChart;
